import { useState } from 'react';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { toast } from 'react-toastify';

import ButtonWithLoader from 'shared/components/Button/ButtonWithLoader/ButtonWithLoader';
import { APIErrorT } from 'shared/models/api';
import { APIInterfaceWithActiveStatusI } from 'utils/api';

interface ButtonActionActiveStatusProps {
  apiCall: APIInterfaceWithActiveStatusI;
  defaultValue: boolean;
  targetId: string; // UserId
  name: string; // user, organization
}
function ButtonActionActiveStatus({
  apiCall,
  defaultValue,
  targetId,
  name,
}: ButtonActionActiveStatusProps) {
  const [isActive, setIsActive] = useState(defaultValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleStatus = () => {
    setIsSubmitting(true);
    const newStatus = !isActive;
    if (window.confirm(`Please confirm to ${newStatus ? 'activate' : 'deactive'} the ${name}`)) {
      apiCall.setActivateStatus(targetId, newStatus)
        .then((resp: any) => {
          if (resp.status >= 400) {
            resp.json()
              .then((error: APIErrorT) => {
                setIsSubmitting(false);
                toast.error(error?.message);
              });
          } else {
            resp.json()
              .then(() => {
                toast.success(`Successfully ${newStatus ? 'activated' : 'deactived'} the ${name}`);
                setIsSubmitting(false);
                setIsActive(newStatus);
              });
          }
        });
    } else {
      setIsSubmitting(false);
    }
  };

  return (
    <ButtonWithLoader
      variant="outlined"
      color={isActive ? 'error' : 'success'}
      startIcon={isActive ? <HighlightOffIcon /> : <CheckCircleOutlineIcon />}
      onClick={toggleStatus}
      label={isActive ? 'Deactivate' : 'Activate'}
      isLoading={isSubmitting}
      tooltip={`${isActive ? 'Deactivate' : 'Activate'} the ${name}`}
    />
  );
}

export default ButtonActionActiveStatus;
